<template>
<div class="h-100">

    <h2 class="step-title" v-text="__('trads.Set-your-payment-method')"></h2>
    <h3 class="subscription-start text-center" v-text="__('trads.Your-subscription-starts-immediately-after-you-set-up-your-payment')"></h3>

    <div class="payment-recap">
        <div class="plan-sub text-left">
            <div class="period" v-text="currentPlan.period"></div>
            <div class="billing-time" v-text="coupon ? currentPlan.promo : currentPlan.time"></div>

            <span
                class="money-saved"
                v-text="__('trads.percent-saved', {percent: 50})"
                v-if="currentPlan.highlighted"
                >
            </span>
        </div>
        <a class="change-plan" @click.prevent="previous" href="">{{ __('trads.Change') }}</a>
    </div>

    <hr class="my-3">

    <div class="secured-payment d-flex">
        {{ __('trads.Secured-payment') }}
        <img src="/img/style/secured-payment.svg">
    </div>

    <div class="checkout-container"></div>

</div>

</template>

<script>
export default {
    props: ['selected', 'email', 'coupon'],
    data () {
        return {
            currentPlan: {}
        }
    },
    beforeMount () {
        for (var n in this.$parent.plans) {
            var plan = this.$parent.plans[n];
            if (this.selected == plan.id) {
                this.currentPlan = plan;
                break;
            }
        }
    },
    mounted () {
        this.open();
    },
    methods: {
        previous () {
            this.$parent.previousStep();
        },
        open () {
            let that = this;
            Paddle.Checkout.open({
                method: 'inline',
                locale: window.locale,
                product: this.selected,
                email: this.email,
                country: window.country,
                postcode: "75000",
                allowQuantity: false,
                disableLogout: true,
                frameTarget: 'checkout-container',
                frameInitialHeight: 450,
                frameStyle: 'width:100%; min-width:312px; background-color: transparent; border: none;',
                successCallback: function(data) {
                    that.$root.$emit('completedCheckout', JSON.stringify(data));
                },
                closeCallback: function(data) {
                    console.log(data);
                    alert('Failed to checkout');
                }
            });
        }
    },
}
</script>

<style>
</style>
